/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useEffect, useState, useContext } from 'react'
import UserContext from './UserContext'
import axios from 'axios'
interface SectionContextProps {
  section: string
  setSection: (section: string) => void
  stockSection: string
  setStockSection: React.Dispatch<React.SetStateAction<string>>
  accessesSection: string
  setAccessesSection: React.Dispatch<React.SetStateAction<string>>
  certificatesSection: string
  setCertificatesSection: React.Dispatch<React.SetStateAction<string>>
  productionFlowSection: string
  setProductionFlowSection: React.Dispatch<React.SetStateAction<string>>
  refreshSection: boolean
  setRefreshSection: React.Dispatch<React.SetStateAction<boolean>>
  routerSection: string
  setRouterSection: React.Dispatch<React.SetStateAction<string>>
}

const SectionContext = createContext<SectionContextProps>({
  section: '',
  setSection: () => {},
  stockSection: '',
  setStockSection: () => {},
  accessesSection: '',
  setAccessesSection: () => {},
  certificatesSection: '',
  setCertificatesSection: () => {},
  productionFlowSection: '',
  setProductionFlowSection: () => {},
  refreshSection: false,
  setRefreshSection: () => {},
  routerSection: '',
  setRouterSection: () => {}
})

export default SectionContext

export const SectionProvider: React.FC<any> = ({ children }) => {
  //TODONOW - Aqui é onde seta a página padrão
  const { user } = useContext(UserContext)
  const [section, setSection] = useState<string>('orders')
  const [stockSection, setStockSection] = useState<string>('stock')
  const [accessesSection, setAccessesSection] = useState<string>('accesses')
  const [certificatesSection, setCertificatesSection] =
    useState<string>('certificates')
  const [ routerSection, setRouterSection ] = useState<string>('freight')
  const [permissions, setPermissions] = useState<string[]>([])
  const [productionFlowSection, setProductionFlowSection] =
    useState<string>('services')
  const [refreshSection, setRefreshSection] = useState<boolean>(false)

  useEffect(() => {
    if (user && user.profileId) {
      const fetchPermissions = async () => {
        const perms = await getPermissions()
        setPermissions(perms) // Atualiza o estado com as permissões obtidas
        setSection(permissions[0]) 
      }

      if (user.profileId) {
        fetchPermissions()
      }
    }
  }, [user])

  useEffect(() => {
    // Verifica se `permissions` foi carregado corretamente
    if (permissions.length > 0) {
      setSection(permissions[0])
    }
  }, [permissions])

  const getPermissions = async () => {
    try {
      //busca as permissões com base no profileId
      const response = await axios(
        `${process.env.REACT_APP_BASE_URL}/profile/find/${user.profileId}`,
      )

      if (response.data) {
        return response.data.permissions
      }
    } catch (error: any) {
      console.log('Usuário sem perfil')
    }
  }

  return (
    <SectionContext.Provider
      value={{
        section,
        setSection,
        stockSection,
        setStockSection,
        accessesSection,
        setAccessesSection,
        certificatesSection,
        setCertificatesSection,
        routerSection,
        setRouterSection,
        productionFlowSection,
        setProductionFlowSection,
        refreshSection,
        setRefreshSection,
      }}
    >
      {children}
    </SectionContext.Provider>
  )
}
